export default __webpack_public_path__ + "static/media/hackathonLogo_2026.c0e4bac3.png";